var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"home",staticStyle:{"height":"100vh"}},[_c('el-aside',{attrs:{"width":"auto"}},[_c('left-menu',{attrs:{"isCollapse":_vm.isCollapse}})],1),_c('el-container',[_c('el-header',[_c('top-menu')],1),_c('el-main',[_c('keep-alive',{attrs:{"include":_vm.cachedViews}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }